// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@200;300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-wrapper {
    background: #EEEEEE 0% 0% no-repeat padding-box;    
    opacity: 1;
    padding:10px;
}

.footer-wrapper .left-content {
    text-align: left;
    font: normal normal normal 16px/40px Open Sans;
    letter-spacing: 1.6px;
    color: #494F54;
    opacity: 1;
}

.footer-wrapper .right-content {
    text-align: left;
    font: normal normal bold 20px/40px Open Sans;
    letter-spacing: 2px;
    color: #494F54;
    opacity: 1;
}

.cta-wrapper {
    background: #3666F6 0% 0% no-repeat padding-box;
    opacity: 1;
    padding: 30px 20px;
}

.cta-wrapper .title {
    color: var(--unnamed-color-ffffff);
    text-align: center;
    font: normal normal normal 35px/40px Manrope;
    letter-spacing: 3.5px;
    color: #FFFFFF;
    /* text-transform: lowercase; */
    opacity: 1;
}

.cta-wrapper .body-text {
    color: var(--unnamed-color-ffffff);
    text-align: center;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0.8px;
    color: #FFFFFF;
    opacity: 1;
    margin-bottom: 30px;
}

.cta-wrapper .btn-secondary {
    background: #FEF8E6 0% 0% no-repeat padding-box;
    opacity: 1;
    border-radius: 0px 32px 0px 35px;
    text-align: left;
    font: normal normal 600 20px/27px Open Sans;
    letter-spacing: 3px;
    color: #494F54;
    text-transform: lowercase;
    opacity: 1;
    padding: 10px;
    height: 60px;
    transition: all 0.3s ease;
}

.cta-wrapper .btn-secondary:hover {
    border: 1px solid #FEF8E6;
    opacity: 1;
    background-color: transparent;
    text-align: left;
    font: normal normal 300 20px/27px Open Sans;
    letter-spacing: 3px;
    color: #FEF8E6;
    text-transform: lowercase;
    opacity: 1;
    border-radius: 0;
    padding: 10px;
    transition: all 0.3s ease;
}

.cta-wrapper .container {
    max-width: 1550px;
}`, "",{"version":3,"sources":["webpack://./src/screens/footer/footer.css"],"names":[],"mappings":"AAEA;IACI,+CAA+C;IAC/C,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;IAC9C,qBAAqB;IACrB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,+CAA+C;IAC/C,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,4CAA4C;IAC5C,qBAAqB;IACrB,cAAc;IACd,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,8CAA8C;IAC9C,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,UAAU;IACV,gCAAgC;IAChC,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,6BAA6B;IAC7B,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@200;300;400;500;600;700;800&display=swap');\n\n.footer-wrapper {\n    background: #EEEEEE 0% 0% no-repeat padding-box;    \n    opacity: 1;\n    padding:10px;\n}\n\n.footer-wrapper .left-content {\n    text-align: left;\n    font: normal normal normal 16px/40px Open Sans;\n    letter-spacing: 1.6px;\n    color: #494F54;\n    opacity: 1;\n}\n\n.footer-wrapper .right-content {\n    text-align: left;\n    font: normal normal bold 20px/40px Open Sans;\n    letter-spacing: 2px;\n    color: #494F54;\n    opacity: 1;\n}\n\n.cta-wrapper {\n    background: #3666F6 0% 0% no-repeat padding-box;\n    opacity: 1;\n    padding: 30px 20px;\n}\n\n.cta-wrapper .title {\n    color: var(--unnamed-color-ffffff);\n    text-align: center;\n    font: normal normal normal 35px/40px Manrope;\n    letter-spacing: 3.5px;\n    color: #FFFFFF;\n    /* text-transform: lowercase; */\n    opacity: 1;\n}\n\n.cta-wrapper .body-text {\n    color: var(--unnamed-color-ffffff);\n    text-align: center;\n    font: normal normal normal 16px/22px Open Sans;\n    letter-spacing: 0.8px;\n    color: #FFFFFF;\n    opacity: 1;\n    margin-bottom: 30px;\n}\n\n.cta-wrapper .btn-secondary {\n    background: #FEF8E6 0% 0% no-repeat padding-box;\n    opacity: 1;\n    border-radius: 0px 32px 0px 35px;\n    text-align: left;\n    font: normal normal 600 20px/27px Open Sans;\n    letter-spacing: 3px;\n    color: #494F54;\n    text-transform: lowercase;\n    opacity: 1;\n    padding: 10px;\n    height: 60px;\n    transition: all 0.3s ease;\n}\n\n.cta-wrapper .btn-secondary:hover {\n    border: 1px solid #FEF8E6;\n    opacity: 1;\n    background-color: transparent;\n    text-align: left;\n    font: normal normal 300 20px/27px Open Sans;\n    letter-spacing: 3px;\n    color: #FEF8E6;\n    text-transform: lowercase;\n    opacity: 1;\n    border-radius: 0;\n    padding: 10px;\n    transition: all 0.3s ease;\n}\n\n.cta-wrapper .container {\n    max-width: 1550px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
